<p-toast position="bottom-right"></p-toast>

<form [formGroup]="form" (ngSubmit)="model ? update() : create()">
    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="sector" class="form-control"
                [placeholder]="'Ingrese código del sector'" [disabled]="model">
            <label>Sector</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="descripcion" class="form-control"
                [placeholder]="'Ingrese descripción del sector'">
            <label>Descripción</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="responsable" class="form-control"
                [placeholder]="'Responsable'" readonly>
            <label>Responsable</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="fechaAlta" class="form-control"
                [placeholder]="'Fecha Captura'" readonly>
            <label>Fecha Captura</label>
        </div>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" (click)="model ? update() : create()"
            [disabled]="!form.valid || loading">
            <mat-icon>save</mat-icon>
            {{ model ? 'Actualizar' : 'Guardar' }}
        </button>
        <button *ngIf="model" mat-flat-button class="btn-search btn-menu" type="button" (click)="openCustomizables()">
            <mat-icon>tune</mat-icon>
            Customizables
        </button>

        <button *ngIf="model" mat-flat-button class="btn-search btn-menu" type="button" (click)="openProForma()">
            <mat-icon>description</mat-icon>
            ProForma
        </button>
    </div>
    <div class="button-section mt-3">
        <button *ngIf="model" mat-flat-button class="btn-search btn-menu" type="button" (click)="openComentarios()">
            <mat-icon>comment</mat-icon>
            Comentarios
        </button>

        <button *ngIf="model" mat-flat-button class="btn-search btn-menu" type="button" (click)="openFinanzas()">
            <mat-icon>account_balance</mat-icon>
            Finanzas
        </button>

        <button *ngIf="model" mat-flat-button class="btn-search btn-menu" type="button" (click)="openAnalisis()">
            <mat-icon>analytics</mat-icon>
            Análisis
        </button>
    </div>
</form>

<!-- Dialog de ProForma -->
<p-dialog
    header="ProForma {{ model?.sector || form.get('sector')?.value }}  | {{ model?.descripcion || form.get('descripcion')?.value }}"
    [(visible)]="displayProFormaDialog" [modal]="true" [style]="{width: '90vw', height: '80vh'}" [draggable]="false"
    [resizable]="false" (onHide)="onProFormaDialogClosed()">

    <app-proforma [sector]="model?.sector || form.get('sector')?.value"
        [descripcion]="model?.descripcion || form.get('descripcion')?.value"
        [visible]="displayProFormaDialog">
    </app-proforma>

</p-dialog>

<!-- Dialog de Comentarios -->
<p-dialog
    header="Comentarios {{ model?.sector || form.get('sector')?.value }}  | {{ model?.descripcion || form.get('descripcion')?.value }}"
    [(visible)]="displayComentariosDialog" [modal]="true" [style]="{width: '90vw', height: '80vh'}" [draggable]="false"
    [resizable]="false" (onHide)="onComentariosDialogClosed()">

    <app-comentarios [sector]="model?.sector || form.get('sector')?.value"
        [descripcion]="model?.descripcion || form.get('descripcion')?.value"
        [visible]="displayComentariosDialog">
    </app-comentarios>

</p-dialog>

<!-- Dialog de Finanzas -->
<p-dialog
    header="Finanzas {{ model?.sector || form.get('sector')?.value }}  | {{ model?.descripcion || form.get('descripcion')?.value }}"
    [(visible)]="displayFinanzasDialog" [modal]="true" [style]="{width: '90vw', height: '80vh'}" [draggable]="false"
    [resizable]="false" (onHide)="onFinanzasDialogClosed()">

    <app-finanzas [sector]="model?.sector || form.get('sector')?.value"
        [descripcion]="model?.descripcion || form.get('descripcion')?.value"
        [visible]="displayFinanzasDialog">
    </app-finanzas>

</p-dialog>

<!-- Dialog de Análisis -->
<p-dialog
    header="Análisis {{ model?.sector || form.get('sector')?.value }}  | {{ model?.descripcion || form.get('descripcion')?.value }}"
    [(visible)]="displayAnalisisDialog" [modal]="true" [style]="{width: '90vw', height: '80vh'}" [draggable]="false"
    [resizable]="false" (onHide)="onAnalisisDialogClosed()">

    <app-analisis [sector]="model?.sector || form.get('sector')?.value"
        [descripcion]="model?.descripcion || form.get('descripcion')?.value"
        [visible]="displayAnalisisDialog">
    </app-analisis>

</p-dialog>